import { useParams } from 'react-router-dom';
import { useConnectModal, useOpenModal } from '@rainbow-modules/hooks';
import { StyledDrawer } from './styled';
import CreateEditPhoneNumberForm from './CreateEditPhoneNumberForm';
import { FormOpenMode } from './CreateEditPhoneNumberForm/types';

const CreateEditPhoneNumberDrawer = ({ modalId }: { modalId: string }) => {
    const { agentId = '' } = useParams();
    const connectedAddModifyProps = useConnectModal(
        modalId,
        { size: 'small', slideFrom: 'right' },
    );

    const [, closeDrawer] = useOpenModal(modalId);
    const {
        mode,
        onCompleted,
        phoneNumberData = {},
        ...drawerProps
    } = connectedAddModifyProps;

    return (
        <StyledDrawer
            {...drawerProps}
            onRequestClose={closeDrawer}
        >
            <CreateEditPhoneNumberForm
                mode={mode as FormOpenMode}
                agentId={agentId}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                onCompleted={onCompleted}
                onRequestClose={closeDrawer}
                {...(phoneNumberData as object)}
            />
        </StyledDrawer>
    );
};

export default CreateEditPhoneNumberDrawer;
